import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  Flex,
  Link,
  CheckIcon,
  SingleSlashCircleIcon,
} from "datastory-shared/ui"
import { useTranslation } from "datastory-shared/utils/i18n"
import {
  startOfDay,
  formatDistance,
  parseISO,
} from "datastory-shared/utils/date"

const PollsTable = ({ metaPolls }) => {
  const { t } = useTranslation("og_page--81503fa2")

  const isArrayMetaPolls = Array.isArray(metaPolls)
  const sortByDate = a =>
    a.sort((a, b) => new Date(b.latestDate) - new Date(a.latestDate))

  const inMamaMetaPolls = isArrayMetaPolls && metaPolls.filter(i => i.inMama)
  const nonMamaMetaPolls = isArrayMetaPolls && metaPolls.filter(i => !i.inMama)
  const sortedMetaPolls = isArrayMetaPolls
    ? [...sortByDate(inMamaMetaPolls), ...sortByDate(nonMamaMetaPolls)]
    : []

  return (
    <>
      <Box
        py="0.5rem"
        borderBottom="1px solid"
        borderColor={"gray.200"}
        fontWeight="700"
      >
        <Flex>
          <Box w={"50%"}>{t("og_page--81503fa2:table-col1")}</Box>
          <Box w={"33%"}>{t("og_page--81503fa2:table-col2")}</Box>
          <Box w={"16.6%"} wordBreak="break-word">
            {t("og_page--81503fa2:table-col3")}
          </Box>
        </Flex>
      </Box>
      {sortedMetaPolls.map(metaPoll => (
        <Box
          key={metaPoll.id}
          py="0.5rem"
          borderBottom="1px solid"
          borderColor={"gray.50"}
        >
          <Flex>
            <Box w={"50%"} overflow="hidden">
              <Link href={metaPoll.url_triple[0]?.url} isExternal>
                {metaPoll.name}
              </Link>
            </Box>
            <Box w={"33%"} overflow="hidden" maxHeight="1.5rem">
              {!!metaPoll.latestDate &&
                formatDistance(
                  startOfDay(parseISO(metaPoll.latestDate)),
                  startOfDay(new Date())
                )}
            </Box>
            <Box w={"16.6%"}>
              {metaPoll.inMama ? (
                <CheckIcon color="green.400" />
              ) : (
                <SingleSlashCircleIcon color="gray.400" />
              )}
            </Box>
          </Flex>
        </Box>
      ))}
    </>
  )
}

PollsTable.propTypes = {
  metaPolls: PropTypes.array,
}

export default PollsTable
